module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_5010.48a0b666.png";